import { Text } from "flicket-ui";
import { DeliveryOptions } from "~components/checkout/checkout.DeliveryOptions";
import { useOrganization, useSDK } from "~hooks";
import { useEffect, useState } from "react";
import { showToast } from "~lib/helpers/showToast";
import { useFormikContext } from "formik";
import { ExpressPageCheckoutFormValues } from "~features/checkout/express/hooks/useExpressCheckoutForm";
import { useSinglePageCheckoutContext } from "../hooks/singlePageCheckoutContext";
import { MobileDivider } from "./MobileDivider";

export const DeliveryOptionsBlock = () => {
  const {
    addToQueue,
    isQueueProcessing: isLoading,
    smsConfirmation,
    order,
  } = useSinglePageCheckoutContext();
  const { isSubmitting } = useFormikContext<ExpressPageCheckoutFormValues>();
  const { organization } = useOrganization();
  const [value, setValue] = useState<"sms" | "digital">(
    order?.smsConfirmationAmount > 0 ? "sms" : "digital"
  );
  const sdk = useSDK();

  const onChangeDeliveryOption = (value: "sms" | "digital") => {
    setValue(value);

    addToQueue(`delivery-option`, async () => {
      try {
        await sdk.updateOrder({
          id: order?.id,
          input: {
            sendSmsConfirmation: value === "sms",
            step: 3,
          },
        });
      } catch (error) {
        showToast("Failed to update delivery option", "error");
        console.error("Failed to update delivery option:", error);
      }
    });
  };

  // This is in case there was an error applying the delivery option and we need to reset the value
  useEffect(() => {
    if (!isLoading) {
      setValue(order?.smsConfirmationAmount > 0 ? "sms" : "digital");
    }
  }, [isLoading, setValue]);

  return (
    !!smsConfirmation?.fee && (
      <>
        <DeliveryOptions
          organization={organization}
          smsConfirmation={smsConfirmation}
          label={<Text variant="header.S">Delivery options</Text>}
          value={value}
          onChange={onChangeDeliveryOption}
          disabled={isSubmitting}
        />
        <MobileDivider />
      </>
    )
  );
};
